export enum CategoryTypeEnum {
  RESPONSE = 'Response',
};